import mixins from 'vue-typed-mixins';

import { Eモニタリング損益差異分析基準値 } from '@/openapi/enum';
import { 勘定科目ListItemResponse, 部門ListItemResponse } from '@/openapi/user';

import PlbscfReadonlyValue from '@/components/plbscfReadonlyValue/PlbscfReadonlyValue.vue';
import PlbscfTableRow from '@/components/plbscfTableRow/PlbscfTableRow.vue';
import C決算期TableHeader from '@/components/決算期TableHeader/決算期TableHeader.vue';
import C部門Select from '@/components/部門Select/部門Select.vue';

import MoneyUnitLabelMixin from '@/entries/user/mixins/MoneyUnitLabelMixin';
import { PlbscfInputableTextId } from '@/entries/user/mixins/PlbscfKeystrokeInputableTextMixin';
import 差異分析Mixin from '@/entries/user/mixins/差異分析Mixin';
import 計画書Mixin from '@/entries/user/mixins/計画書Mixin';

import 差異分析Service, { 月次推移, 累計, 累計ListItem } from '@/classes/service/モニタリング/差異分析Service';

export default mixins(MoneyUnitLabelMixin, 計画書Mixin, 差異分析Mixin).extend({
  name: 'C差異分析損益計算書',

  components: {
    PlbscfReadonlyValue,
    PlbscfTableRow,
    C決算期TableHeader,
    C部門Select,
  },

  data(): {
    勘定科目s: 勘定科目ListItemResponse[];
    部門s: 部門ListItemResponse[];
    部門pk: number | undefined;
    eモニタリング損益差異分析基準値: typeof Eモニタリング損益差異分析基準値;
    vモニタリング損益差異分析基準値: Eモニタリング損益差異分析基準値;
  } {
    return {
      勘定科目s: this.service.get勘定科目s,
      部門s: this.service.get部門s,
      部門pk: undefined,
      eモニタリング損益差異分析基準値: Eモニタリング損益差異分析基準値,
      vモニタリング損益差異分析基準値: Eモニタリング損益差異分析基準値.年度合計,
    };
  },

  computed: {
    is部門合計(): boolean {
      return this.部門pk === undefined;
    },
    pl(): { 月次推移: 月次推移; 累計: 累計; 部門pk?: number } | undefined {
      return this.差異分析.pls.find((pl) => pl.部門pk === this.部門pk);
    },
    map(): PlbscfInputableTextId[][] {
      if (this.is部門合計 || this.pl === undefined) return [];
      return this.createMapBy月次推移List(this.pl.月次推移.list);
    },
    累計ListItems(): 累計ListItem[] {
      if (this.pl === undefined) return [];
      return 差異分析Service.get累計ListItemsBy基準値(this.pl.累計.list, this.vモニタリング損益差異分析基準値);
    },
    基準値Key(): keyof typeof Eモニタリング損益差異分析基準値 {
      return 差異分析Service.get基準値Key(this.vモニタリング損益差異分析基準値);
    },
  },

  watch: {
    部門pk(): void {
      if (this.is部門合計) return;
      this.setFirstId();
    },
    keystrokeResetCount(): void {
      this.setFirstId();
    },
  },

  methods: {
    hasValue(listItem: 累計ListItem): boolean {
      return listItem.value !== undefined;
    },
  },
});
